/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Cps_TitleInputs */

const en_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters per second`)
};

const fr_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres par seconde`)
};

const de_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen pro Sekunde`)
};

const it_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri al secondo`)
};

const ru_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Символов в секунду`)
};

const es_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres por segundo`)
};

const zh_cn2_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每秒字符数`)
};

const ja_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒あたりの文字数`)
};

const hi_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ण प्रति सेकंड`)
};

const pt_pt2_summary_cps_title = /** @type {(inputs: Summary_Cps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres por segundo`)
};

/**
* | output |
* | --- |
* | "Characters per second" |
*
* @param {Summary_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_cps_title = /** @type {((inputs?: Summary_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_cps_title(inputs)
	if (locale === "de") return de_summary_cps_title(inputs)
	if (locale === "it") return it_summary_cps_title(inputs)
	if (locale === "ru") return ru_summary_cps_title(inputs)
	if (locale === "es") return es_summary_cps_title(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_cps_title(inputs)
	if (locale === "ja") return ja_summary_cps_title(inputs)
	if (locale === "hi") return hi_summary_cps_title(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_cps_title(inputs)
	return en_summary_cps_title(inputs)
});